import { autobind } from 'core-decorators';
import BaseStore from '@src/utils/store/base-store';
import routeConfigs from '@src/pages/app-router/route-configs';
import { ARTICLE_TITLE } from '@src/constants/articles';
import $$tracker from '@src/tracker';

class MainStore extends BaseStore {
  use() {
    super.use();
  }

  /**
   * 跳转至对应内页（单路由 /list/:id）
   * @param {string} id - 内页 slug，如 'battle-territory'
   */
  @autobind
  navToList(id) {
    $$tracker.clickMenu(ARTICLE_TITLE[id]);
    this.redirect(routeConfigs.LIST.path.replace(':id', id));
  }
}

export default MainStore;
